import React from 'react'
import { Tile, TileCaption } from '@mc/design-system'
import {
  MobileBackgroundImage,
  DesktopBackgroundImage,
} from './BackgroundImage'
import { Content } from './Content'
import classes from './Hero.module.scss'

export const Hero = () => (
  <section className='mc-mb-10'>
    {/* Desktop and Tablet */}
    <div className='d-none d-md-block'>
      <Tile style={{ height: 700 }}>
        <DesktopBackgroundImage />

        <TileCaption position='center bottom'>
          <Content />
        </TileCaption>
      </Tile>
    </div>

    {/* Mobile */}
    <div className='d-block d-md-none'>
      <MobileBackgroundImage />

      <div className={classes.contentContainer__mobile}>
        <Content />
      </div>
    </div>
  </section>
)
